import React, {Component} from 'react';
import {
    Button,
    Modal,
    Message,
    Card,
    Image
} from 'semantic-ui-react';
import Alert from "../extras/Alert";
import update from 'react-addons-update';

import ImageUploadDialog from "../extras/ImageUploadDialog";
import Loading from "../extras/Loading";
import DataService from "../../functions/DataService";

class ImagesDialog extends Component {

    constructor() {
        super();

        this.state = {
            open: false,
            open_dialog: false,
            title: "",
            label_button: " ",
            id: null,
            images: [],
            url: '',
            ingredientError: '',
            loading: true,
            deleting: null
        };

        this.handleImageDialog = this.handleImageDialog.bind(this);
    }

    async initialFetch(pk, url) {
        DataService.get(url, {}).then(images=>{
            this.setState({images, loading:false});
        })
    }

    loadData = (title, id, url) => {
        this.setState({images: [], id, url});
        this.initialFetch(id, `${url}/${id}`);
        this.setState({open: true, title, url});
    };

    handleClose = () => {
        this.setState({open: false, loading:true});
    };

    handleOpen = () => {
        this.setState({open: true});
    };

    handleImageDialog = () => {
        this.refs.uploadDialog.handleOpen(this.state.id);
    };

    handleAddImage = (image) => {
        DataService.post({picture: image}, `${this.state.url}/${this.state.id}`, (res) =>{
            this.refs.uploadDialog.handleClose();
            if (res.hasOwnProperty('id')) {
                let oldData = this.state.images.slice();
                oldData.push(res);
                let data = update(this.state, {
                    images: {
                        $set: oldData
                    }
                });
                this.setState(data);
            }else{
                this.refs.alert.open({message:'Tenemos un problema!', type:'error'});
            }
            this.setState({loading:false});
        });
    };

    async handleDelete(index, pk) {
        let uuid = this.state.images[index];
        this.setState({deleting:pk});

        DataService.delete(`${this.state.url}/${uuid.id}`, (res) =>{
            if (res === null) {
                let oldData = this.state.images.slice();
                oldData.splice(index, 1);
                let data = update(this.state, {
                    images: {
                        $set: oldData
                    }
                });
                this.setState(data);
                this.refs.alert.open({message: 'Imagen Borrada!', type: 'success'});
            } else {
                this.refs.alert.open({message: 'Tenemos un problema!', type: 'error'});
            }
        });
    }

    render() {

        let gridTiles = this.state.images.map(function (image, index) {
            return (
                <Card raised key={image.id}>
                    <Image src={image.image} height='120'/>
                    <Card.Content extra>
                        <Button primary fluid content='Borrar' icon='trash' labelPosition='left' loading={this.state.deleting === image.id} disabled={this.state.deleting === image.id}
                                onClick={() => this.handleDelete(index, image.id)}/>
                    </Card.Content>
                </Card>
            )
        }, this);

        let list = <Card.Group itemsPerRow={4}>
            {gridTiles}
        </Card.Group>;

        let data = (this.state.images.length > 0 ? list : <Message icon='bell' header='No hay información registrada'/>);

        return (
            <div>
                <Modal open={this.state.open} size='small' onClose={this.handleClose} dimmer='inverted'>
                    <Modal.Header>{`Imágenes - ${this.state.title}`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {this.state.loading ? <Loading/> : null}
                            {this.state.loading ? null : data}
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.handleClose} icon='x' labelPosition='left' content="Cerrar"/>
                        <Button primary icon='image' labelPosition='left' content="Agregar Imagen"
                                onClick={this.handleImageDialog}/>
                    </Modal.Actions>
                </Modal>
                <Alert ref='alert'/>
                <ImageUploadDialog ref="uploadDialog" title="Imagen de producto"
                                   callbackLoadImage={this.handleAddImage}/>
            </div>
        );
    }
}

export default ImagesDialog;



// WEBPACK FOOTER //
// ./src/components/utils/ImagesDialog.js